"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.endsWith = exports.startsWith = exports.pattern = exports.format = exports.string = exports.StringGuard = void 0;
var guard_1 = require("../guard");
var STRING_FORMAT = {
    base64: /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/,
    camelcase: /^[a-z]+(?:[A-Z][a-z]+)*$/,
    'date-iso8601': /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])T(0[0-9]|1[0-9]|2[0-3]):[0-5]\d:[0-5]\d\.\d{3}Z$/i,
    // email regex source: https://github.com/epoberezkin/ajv/blob/d5edde43752e8c1bdb26074402452a41fe0742cb/lib/compile/formats.js#L46
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    'gregorian-date': /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/,
    'gregorian-year': /^\d{4}$/,
    integer: /^-?\d+$/,
    'non-negative-integer': /^\d+$/,
    kebabcase: /^[a-z][a-z0-9-]*$/,
    number: /^(-|\+)?\d+\.?\d*$/,
    pascalcase: /^[A-Z][a-z]+(?:[A-Z][a-z]+)*$/,
    snakecase: /^[a-z][a-z0-9_]*$/,
    time12h: /^(0[1-9]|1[0-2]):[0-5]\d(am|pm)$/,
    time24h: /^([01][0-9]|2[0-3]):[0-5]\d$/,
    'time24h-full': /^([01][0-9]|2[0-3]):[0-5]\d:[0-5]\d$/,
    uuid: /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
};
var STRING_FORMAT_KEYS = Object.freeze(Object.keys(STRING_FORMAT).sort());
var StringGuard = /** @class */ (function (_super) {
    __extends(StringGuard, _super);
    function StringGuard(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _a = __assign({}, options), exclusiveMaximum = _a.exclusiveMaximum, exclusiveMinimum = _a.exclusiveMinimum, maximum = _a.maximum, minimum = _a.minimum, patternOption = _a.pattern, blank = _a.blank, trim = _a.trim, startsWith = _a.startsWith, endsWith = _a.endsWith, format = _a.format, lengthOption = _a.length;
        if (exclusiveMaximum !== undefined && typeof exclusiveMaximum !== 'string') {
            throw new Error('"exclusiveMaximum" must be undefined or a string');
        }
        if (exclusiveMinimum !== undefined && typeof exclusiveMinimum !== 'string') {
            throw new Error('"exclusiveMinimum" must be undefined or a string');
        }
        if (maximum !== undefined && typeof maximum !== 'string') {
            throw new Error('"maximum" must be undefined or a string');
        }
        if (minimum !== undefined && typeof minimum !== 'string') {
            throw new Error('"minimum" must be undefined or a string');
        }
        if (startsWith !== undefined && typeof startsWith !== 'string') {
            throw new Error('"startsWith" must be undefined or a string');
        }
        if (endsWith !== undefined && typeof endsWith !== 'string') {
            throw new Error('"endsWith" must be undefined or a string');
        }
        var pattern = typeof patternOption === 'string'
            ? new RegExp(patternOption)
            : patternOption instanceof RegExp
                ? patternOption
                : undefined;
        if (pattern !== undefined && pattern instanceof RegExp === false) {
            throw new Error('"pattern" must be undefined, a string or a instance of RegExp');
        }
        if (blank !== undefined && typeof blank !== 'boolean') {
            throw new Error('"blank" must be undefined or a boolean');
        }
        if (trim !== undefined && typeof trim !== 'boolean') {
            throw new Error('"trim" must be undefined or a boolean');
        }
        if (format !== undefined && STRING_FORMAT_KEYS.includes(format) === false) {
            var formatNames = STRING_FORMAT_KEYS.map(function (formatName) { return "\"" + formatName + "\""; });
            var firstNames = formatNames.slice(0, -1);
            var lastName = formatNames.slice(-1);
            var formatsLiteral = firstNames.join(', ') + ' and ' + lastName;
            throw new Error("\"format\" must be undefined or one of " + formatsLiteral);
        }
        if (false ===
            (lengthOption === undefined ||
                (typeof lengthOption === 'number' && lengthOption % 1 === 0 && lengthOption >= 0) ||
                (typeof lengthOption === 'object' &&
                    lengthOption !== null &&
                    (lengthOption.max === undefined ||
                        (typeof lengthOption.max === 'number' && lengthOption.max % 1 === 0 && lengthOption.max >= 0)) &&
                    (lengthOption.min === undefined ||
                        (typeof lengthOption.min === 'number' && lengthOption.min % 1 === 0 && lengthOption.min >= 0))))) {
            throw new Error('"length" must be undefined, a non-negative integer or an object with properties "max" and "min" either as undefined or a non-negative integer');
        }
        var _b = (options === null || options === void 0 ? void 0 : options.length) === undefined
            ? {}
            : typeof options.length === 'number'
                ? { length: options.length }
                : options.length, maxLength = _b.max, minLength = _b.min, length = _b.length;
        _this = _super.call(this, {
            type: 'string',
            coerce: function (path, value, coercer) {
                if (typeof value === 'string') {
                    if (trim === true) {
                        return value.trim();
                    }
                }
                return value;
            },
            validate: function (path, value) {
                var trimmed, formatPattern;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(typeof value !== 'string')) return [3 /*break*/, 2];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'type',
                                    setting: 'string',
                                    actual: value
                                }];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 26];
                        case 2:
                            if (!(exclusiveMaximum !== undefined && exclusiveMaximum <= value)) return [3 /*break*/, 4];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'exclusiveMaximum',
                                    setting: exclusiveMaximum,
                                    actual: value
                                }];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (!(exclusiveMinimum !== undefined && exclusiveMinimum >= value)) return [3 /*break*/, 6];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'exclusiveMinimum',
                                    setting: exclusiveMinimum,
                                    actual: value
                                }];
                        case 5:
                            _a.sent();
                            _a.label = 6;
                        case 6:
                            if (!(maximum !== undefined && maximum < value)) return [3 /*break*/, 8];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'maximum',
                                    setting: maximum,
                                    actual: value
                                }];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            if (!(minimum !== undefined && minimum > value)) return [3 /*break*/, 10];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'minimum',
                                    setting: minimum,
                                    actual: value
                                }];
                        case 9:
                            _a.sent();
                            _a.label = 10;
                        case 10:
                            if (!(startsWith !== undefined && value.startsWith(startsWith) === false)) return [3 /*break*/, 12];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'startsWith',
                                    setting: startsWith,
                                    actual: value
                                }];
                        case 11:
                            _a.sent();
                            _a.label = 12;
                        case 12:
                            if (!(endsWith !== undefined && value.endsWith(endsWith) === false)) return [3 /*break*/, 14];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'endsWith',
                                    setting: endsWith,
                                    actual: value
                                }];
                        case 13:
                            _a.sent();
                            _a.label = 14;
                        case 14:
                            if (!(pattern !== undefined && pattern.test(value) === false)) return [3 /*break*/, 16];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'pattern',
                                    setting: pattern.toString(),
                                    actual: value
                                }];
                        case 15:
                            _a.sent();
                            _a.label = 16;
                        case 16:
                            if (!(blank === false)) return [3 /*break*/, 18];
                            trimmed = value.trim();
                            if (!(trimmed.length === 0)) return [3 /*break*/, 18];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'blank',
                                    setting: blank,
                                    actual: value
                                }];
                        case 17:
                            _a.sent();
                            _a.label = 18;
                        case 18:
                            if (!(format !== undefined)) return [3 /*break*/, 20];
                            formatPattern = STRING_FORMAT[format];
                            if (!(formatPattern.test(value) === false)) return [3 /*break*/, 20];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'format',
                                    setting: format,
                                    actual: value
                                }];
                        case 19:
                            _a.sent();
                            _a.label = 20;
                        case 20:
                            if (!(length !== undefined && value.length !== length)) return [3 /*break*/, 22];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length',
                                    setting: length,
                                    actual: value.length
                                }];
                        case 21:
                            _a.sent();
                            _a.label = 22;
                        case 22:
                            if (!(maxLength !== undefined && value.length > maxLength)) return [3 /*break*/, 24];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length.max',
                                    setting: maxLength,
                                    actual: value.length
                                }];
                        case 23:
                            _a.sent();
                            _a.label = 24;
                        case 24:
                            if (!(minLength !== undefined && value.length < minLength)) return [3 /*break*/, 26];
                            return [4 /*yield*/, {
                                    path: path,
                                    rule: 'length.min',
                                    setting: minLength,
                                    actual: value.length
                                }];
                        case 25:
                            _a.sent();
                            _a.label = 26;
                        case 26: return [2 /*return*/];
                    }
                });
            }
        }) || this;
        return _this;
    }
    return StringGuard;
}(guard_1.Guard));
exports.StringGuard = StringGuard;
var DEFAULT_STRING = new StringGuard();
/**
 * Constructs a type-guard for a `string`
 * @param options.maximum inclusive maximal value
 * @param options.minimum inclusive minimum value
 * @param options.exclusiveMaximum exclusive maximal value
 * @param options.exclusiveMinimum exclusive minial value
 * @param options.pattern check that value matches regular expression
 * @param options.length check exact length
 * @param options.length.max exclusive maximal length
 * @param options.length.min exclusive minimal length
 * @param options.blank allow blank strings (empty or space only are considered blank)
 * @param options.trim trim blank substrings from start and end of string when coercing
 * @param options.format force string to match predefined format (ie. email or uuid)
 * @param options.startsWith value must start with a substring
 * @param options.endsWith value must end with a substring
 */
function string(options) {
    return options === undefined ? DEFAULT_STRING : new StringGuard(options);
}
exports.string = string;
var STRING_FORMATS = Object.fromEntries(STRING_FORMAT_KEYS.map(function (format) { return [format, string({ format: format })]; }));
/**
 * Constructs a type-guard for a `string` of specified format
 * @param format force string to match predefined format (ie. email or uuid)
 */
function format(format) {
    return STRING_FORMATS[format];
}
exports.format = format;
/**
 * Constructs a type-guard for a `string` of specified pattern
 * @param pattern check that value matches regular expression
 */
function pattern(pattern) {
    return string({ pattern: pattern });
}
exports.pattern = pattern;
/**
 * Constructs a type-guard for a `string` with specified prefix
 * @param prefix value must start with a prefix
 */
function startsWith(prefix) {
    return string({ startsWith: prefix });
}
exports.startsWith = startsWith;
/**
 * Constructs a type-guard for a `string` with specified suffix
 * @param endsWith value must end with a suffix
 */
function endsWith(suffix) {
    return string({ endsWith: suffix });
}
exports.endsWith = endsWith;
